import bb from "blingblingjs";
import { state, previousState, setState } from "./state";
import smoothScroll from 'smoothscroll';
import { breakpoints } from "../../config";
import {
    createEventsManager,
    getProductJson,
    getStepTypes,
    getVariant
} from "./utilities";
import { getInitialStepData } from "./createStepData";
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from "body-scroll-lock";
import { createStepData } from "./createStepData";
import {headroom} from '../../header';
const config = {
    stepTypes: ["filter", "root", "splitOption", "option", "option"]
};
var anchor = document.querySelector("#add-to-basket");

export const events = createEventsManager();
/* -------------------- Open the configurator -------------------- */
function openConfigurator() {
    //disableBodyScroll(anchor);
    headroom.unpin()
    headroom.freeze()
    smoothScroll(anchor, 500, () => {headroom.unfreeze(); headroom.unpin();});
    let configuratorOpenEvent = new Event('configurator:open', {"bubbles":true, "cancelable": false});
    window.dispatchEvent(configuratorOpenEvent);

    setState({
        ...state,
        configuratorIsOpen: true
    });
}
events.add(".js-fn__configurator-open", "click", openConfigurator);

/* -------------------- Close the configurator -------------------- */
function closeConfigurator() {
    //enableBodyScroll(anchor);
    let configuratorOpenEvent = new Event('configurator:close', {"bubbles":true, "cancelable": false});
    window.dispatchEvent(configuratorOpenEvent);

    setState({
        ...state,
        configuratorIsOpen: false
    });
}
events.add(".js-fn__configurator-close", "click", closeConfigurator);

/* -------------------- Goto next step -------------------- */
function gotoNextStep() {

   if (state.currentStep != getStepTypes().length + 1) {
        setState({
            ...state,
            currentStep: Number(state.currentStep) + 1,
            currentSubStep: 1,
            infoPopup: null
        });
    }
}
events.add(".js-fn__configurator-next-step", "click", gotoNextStep);

/* -------------------- Goto prev step -------------------- */
function gotoPrevStep() {

    if (state.currentSubStep != 1) {
        setState({
            ...state,
            currentSubStep: 1,
            infoPopup: null
        });
    }
    else if (state.currentStep != 1) {
        setState({
            ...state,
            currentStep: Number(state.currentStep) - 1,
            currentSubStep: 1,
            infoPopup: null
        });
    }
}
events.add(".js-fn__configurator-prev-step", "click", gotoPrevStep);

/* -------------------- Goto (n) step -------------------- */
function gotoStep(e) {
    const step = e.currentTarget.dataset.targetStep;
    setState({
        ...state,
        currentStep: step,
        currentSubStep: 1,
        infoPopup: null
    });
}
events.add(".js-fn__configurator-goto-step", "click", gotoStep);

/* -------------------- Goto step split -------------------- */
function gotoSubstep(e) {
    const substep = e.currentTarget.dataset.targetSubstep;
    setState({
        ...state,
        currentSubStep: substep,
        infoPopup: null
    });
}
events.add(".js-fn__configurator-goto-substep", "click", gotoSubstep);

/* -------------------- Choose an option -------------------- */
function setOption(e) {

    var currentTarget = e.currentTarget;
    console.log("Outside CreateStepData " + currentTarget);
    createStepData(currentTarget.dataset, state.product).then(val => {
        console.log("Inside CreateStepData " + currentTarget);
        const [ newChosenOptions, newStepData, product ] = val;
        var stepExpanded = state.stepExpanded;
        if(currentTarget.dataset.minimisestep == 1){
            stepExpanded = false;
        }

        // added for hiding swopper spring color step
        let _product_type = product.product.product_type?.toLowerCase();
        if (_product_type && (_product_type == 'swopper' || _product_type.includes('swopper '))) {
            newChosenOptions[2][1] = newChosenOptions[2][0];
        }
        setState({
            ...state,
            chosenOptions: newChosenOptions,
            stepData: newStepData,
            infoPopup: null,
            product,
            stepExpanded: stepExpanded
        });
    });
}
events.add(".js-fn__configurator-set-option", "click", setOption);

/* -------------------- Set hover info -------------------- */

function setOptionHoverInfo(e) {
    if(state.hoverInfo != e.currentTarget.dataset.value && window.innerWidth > Number(breakpoints.m)) {
        setState({
            ...state,
            hoverInfo : e.currentTarget.dataset.value
        });
    }
}
events.add(".js-fn__configurator-set-option", "mouseenter", setOptionHoverInfo);

function unsetOptionHoverInfo(e) {
    if(state.hoverInfo != null) {
        setState({
            ...state,
            hoverInfo : null
        });
    }
}
events.add(".js-fn__configurator-set-option", "mouseleave", unsetOptionHoverInfo);


/* -------------------- Set Root Product (colour) -------------------- */

function setRootProduct(e) {
    const clickedEl = e.currentTarget;
    const product_handle = clickedEl.dataset.productHandle;

    getProductJson(product_handle).then(product => {
        createStepData(clickedEl.dataset, product).then(val => {
            const [ newChosenOptions, newStepData ] = val;

            setState({
                ...state,
                chosenOptions: newChosenOptions,
                stepData: newStepData,
                infoPopup: null,
                product
            });
        });
    });
}
events.add(".js-fn__configurator-set-root-product", "click", setRootProduct);

/* -------------------- Open a info popup -------------------- */

function showInfoPopup(e) {
    const popup = e.currentTarget.dataset.popup;
    setState({
        ...state,
        infoPopup: popup
    });
}
events.add(".js-fn__configurator-show-info-popup", "click", showInfoPopup);

/* -------------------- Open a info popup -------------------- */

function hideInfoPopup() {
    setState({
        ...state,
        infoPopup: false
    });
}
events.add(".js-fn__configurator-hide-info-popup", "click", hideInfoPopup);



/* -------------------- Toggle Tach Specs -------------------- */

function toggleTechSpecs() {
    setState({
        ...state,
        techSpecsIsOpen: !state.techSpecsIsOpen
    });
}
events.add(".js-fn__configurator-toggle-tech-specs", "click", toggleTechSpecs);

/* -------------------- Close popups (tech specs / info popups) -------------------- */

function closePopups() {
    setState({
        ...state,
        techSpecsIsOpen: false,
        infoPopup: false
    });
}
events.add(".js-fn__configurator-close-popups", "click", closePopups);

/* -------------------- Expand Step -------------------- */

function expandStep() {

    var numoFirstSpring = bb('.numo-has-spring[data-value="federbein standard"]')[0];

    createStepData(numoFirstSpring.dataset, state.product).then(val => {
        const [ newChosenOptions, newStepData, product ] = val;

        setState({
            ...state,
            chosenOptions: newChosenOptions,
            stepData: newStepData,
            infoPopup: null,
            product,
            stepExpanded: true
        });
    });
}
events.add(".show-more_numo-task-spring", "click", expandStep);

/* -------------------- Close popups (tech specs / info popups) -------------------- */

function toggleDownloads() {
    setState({
        ...state,
        downloadsIsOpen: !state.downloadsIsOpen
    });
}
events.add(".js-fn__toggle-product-downloads", "click", toggleDownloads);

/* -------------------- Popular Variants -------------------- */

function setVariant(e) {
    const clickedEl = e.currentTarget;
    const productHandle = clickedEl.dataset.productHandle;
    const variantID = clickedEl.dataset.variant;
    //const stepChoices = clickedEl.dataset.stepChoices;
    var anchor = document.querySelector("#add-to-basket");
    smoothScroll(anchor, 500, () => {headroom.unfreeze(); headroom.unpin();});

    getProductJson(productHandle) // TODO - use handle from URL
        .then(product => {
            window.currentProduct = product.product;
            window.currentProduct.variants = window.currentProduct.variants.map((item, index)=>{ item.available = state.product.meta.variants[index]?.available || false; return item});
            let variant = product.product.variants.find((variant)=>{ return variant.id == variantID});
            window.currentProduct.selectedVariant = variant;
            if (window.currentProduct.selectedVariant) {
                window.currentProduct.selectedVariant.price = window.currentProduct.selectedVariant.price * 100;
            }
            const { newChosenOptions, newStepData } = getInitialStepData(
                product,
                variantID,
                []
                //stepChoices
            );
            setState({
                ...state,
                chosenOptions: newChosenOptions,
                stepData: newStepData,
                product,
                firstRun: true
            });
            
        });
}
events.add(".js-fn__set-variant", "click", setVariant);

/* -------------------- Add to` basket -------------------- */

bb(".js-fn__add-variant-to-basket").on("click", () => {
    let selectedVariant = getVariant(state, getStepTypes());
    window.currentProduct = JSON.parse(JSON.stringify(state.product.product));
    window.currentProduct.variants = window.currentProduct.variants.map((item, index)=>{ item.available = state.product.meta.variants[index].available; return item});
    window.currentProduct.selectedVariant = window.currentProduct.variants.find((variant)=>{ return variant.id == selectedVariant.id});
    window.currentProduct.selectedVariant.price = window.currentProduct.selectedVariant.price * 100;
    window.CartJS.addItem(selectedVariant.id);

    let foundItemInCart = CartJS.cart.items.find((x)=>{
        return x.id == window.currentProduct.selectedVariant.id;
    });
    if (!foundItemInCart) {
        var event = new Event("addedToCartDatalayer");
        window.dispatchEvent(event);
    }
    // Dispatch the event.
    var _event = new Event("addedToCart");
    // Dispatch the event.
    window.dispatchEvent(_event);
});



/* -------------------- Image Zooms -------------------- */

bb('.js-el__image-zoom').on('click', e => {
    if (window.innerWidth >= 900) {
        bb('.js-el__add-to-basket-container')[0].classList.toggle('--has-active-zoom');
    }
});

bb('.js-el__configurator-preview-col').on('mouseleave', () => {
    if (window.innerWidth >= 900) {
        bb('.js-el__add-to-basket-container')[0].classList.remove('--has-active-zoom');
    }
});
